import React, { Component } from 'react';
import ScrollToNext from '../ScrollToNext/ScrollToNext';
import { injectIntl } from 'react-intl';
import './SectionTwo.css';
import { Row, Col } from 'antd';
import { connect } from 'react-redux';
import { getLocale } from '../../utils/locale';

class SectionTwo extends Component {
  backgroundImage(lang) {
    const locale = lang.split('-')[0];
    const localePath = lang.split('-')[1];
    switch(locale){
      case 'zh' : return 'CN';
      case 'th' : return locale.toUpperCase();
      case 'id' : return locale.toUpperCase();
      case 'vi' : return 'VN';
      default: return 'EN';
    };
  }

  render() {
    return (
      <div className="section2-content section-background section-two">
        {/* <div className="section-two-content"> 
            
        </div> */}
        <Row type='flex'>
          <Col sm={24}>
            <div className={ "section2-content section-two-content-description-image-" + this.backgroundImage(getLocale())} />
          </Col>
        </Row>
        <ScrollToNext pageSelector=".section-three-background" arrow ="blue"/>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    mobile: state.responsiveui.mobile
  };
};

export default injectIntl(connect(
  mapStateToProps
  )(SectionTwo)
);